interface Props {
  contractBalance?: number | null;
  hidePaymentDetails?: boolean;
  promoCodeSuccess?: string;
  totalOrderNetPrice?: number;
  isPerUnitBilling?: boolean;
}

export const hasSufficientBudget = (
  contractBalance?: number | null,
  totalOrderNetPrice?: number,
) => {
  const costDifference = Number(contractBalance) - Number(totalOrderNetPrice);

  return Boolean(typeof contractBalance === 'number' && costDifference <= 0);
};

export function getPaymentDetailsHidden({
  contractBalance,
  hidePaymentDetails,
  promoCodeSuccess,
  totalOrderNetPrice,
  isPerUnitBilling = false,
}: Props) {
  const isOverage = hasSufficientBudget(contractBalance, totalOrderNetPrice);

  const isPromoSuccessfullyApplied = Boolean(
    promoCodeSuccess && totalOrderNetPrice === 0,
  );

  const isFreeProduct = Number(totalOrderNetPrice) === 0;

  if (isPerUnitBilling) {
    return false;
  }

  return (
    hidePaymentDetails ||
    isFreeProduct ||
    isOverage ||
    isPromoSuccessfullyApplied
  );
}
